import React from "react";
import {Link} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";

export default function StyledLink(props: any) {
  return <Link underline="none" component={RouterLink} {...props} />;
}
